import { BaseViewModel } from "@iot-platform/core";
import { SpatialLevels } from "@station/domain/models/spatial-level.model.ts";
import type { Station } from "@station/domain/models/station.model.ts";
import { SpatialLevelGetAllUseCase } from "@station/domain/usecases/spatial-level-get-all.usecase";
import { StationAddSelectedUseCase } from "@station/domain/usecases/station-add-selected.usecase.ts";
import { StationGetSelectedUseCase } from "@station/domain/usecases/station-get-selected.usecase.ts";
import { StationRemoveSelectedUseCase } from "@station/domain/usecases/station-remove-selected.usecase.ts";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class StationListMobileViewmodel extends BaseViewModel {
    @observable
    spatialLevels: SpatialLevels = SpatialLevels.empty();

    @observable
    selectedStations: readonly Readonly<Station>[] = [];

    constructor(
        @inject(SpatialLevelGetAllUseCase)
        private readonly spatialLevelGetAllUseCase: SpatialLevelGetAllUseCase,
        @inject(StationGetSelectedUseCase)
        private readonly stationGetSelectedUseCase: StationGetSelectedUseCase,
        @inject(StationAddSelectedUseCase)
        private readonly stationAddSelectedUseCase: StationAddSelectedUseCase,
        @inject(StationRemoveSelectedUseCase)
        private readonly stationRemoveSelectedUseCase: StationRemoveSelectedUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    async initViewData(): Promise<void> {
        await this.fetchSpatialLevels();
        this.addSub(
            this.stationGetSelectedUseCase.execute().subscribe((stations) => {
                runInAction(() => {
                    this.selectedStations = stations;
                });
            }),
        );
    }

    private async fetchSpatialLevels(): Promise<void> {
        this.spatialLevels = await this.spatialLevelGetAllUseCase.execute();
    }

    @action
    addStation(station: Readonly<Station> | Readonly<Station>[]): void {
        this.stationAddSelectedUseCase.execute(station);
    }

    @action
    removeStation(station: Readonly<Station> | Readonly<Station>[]): void {
        this.stationRemoveSelectedUseCase.execute(station);
    }
}
